/**
 * MessageList Component
 *
 * Status: [IMPLEMENTED]
 * Task: T2.1 - Chat UI Component
 *
 * Displays all messages in a scrollable container.
 */

import React, { useEffect, useRef } from 'react';
import Message from './Message';
import TypingIndicator from './TypingIndicator';

const MessageList = ({ messages, isLoading }) => {
  const messagesEndRef = useRef(null);

  // Auto-scroll to bottom when new messages arrive
  useEffect(() => {
    if (messagesEndRef.current?.scrollIntoView) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [messages, isLoading]);

  return (
    <div
      className="flex-1 overflow-y-auto p-4 space-y-4"
      role="log"
      aria-live="polite"
      aria-label="Chat messages"
    >
      {messages.length === 0 && !isLoading && (
        <div className="text-center text-gray-500 dark:text-slate-400 py-8">
          <p className="text-lg mb-2">Hi there!</p>
          <p className="text-sm">
            Ask me anything about Raja's professional experience, skills, or projects.
          </p>
        </div>
      )}

      {messages.map((message) => (
        <Message
          key={message.id}
          role={message.role}
          content={message.content}
          timestamp={message.timestamp}
        />
      ))}

      {isLoading && <TypingIndicator />}

      {/* Scroll anchor */}
      <div ref={messagesEndRef} />
    </div>
  );
};

export default MessageList;
